import Vue from 'vue';
import App from './App.vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './css/main.less';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueSimpleMarkdown from 'vue-simple-markdown';
import * as Sentry from "@sentry/vue";

Sentry.init({
  Vue: Vue,
  dsn: 'https://ac2c380ca6bc42a39bc72696f71b1b5e@sentry.rlab.io/8',
  logErrors: true,
});

import router from './router';
import store from "./store";
import {addRequestHeader} from "@/helpers";

Vue.config.productionTip = false;

export const apiUrl = process.env.VUE_APP_COLORSJP_API_URL;

const token = localStorage.getItem('user-token');
if (token) {
  addRequestHeader('Authorization', token);
}

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueSimpleMarkdown);
Vue.component('multiselect', Multiselect);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
